import type { AxiosResponse } from "axios"

import { httpPost } from "../http"

export type v2GetHomeSessionBody = {}

export interface NetworkInfo {
  ip: string
  provider: string
  network_type: string
}

export interface HomeSessionV2 {
  code: number
  msg: string
  sessions: HomeSession[]
  background_image: string
  text_color: string
  weather: Weather
  testing_background_image: string
}

interface Weather {
  brief_weather_content_vi: string
  brief_weather_content_en: string
  weather_icon_link: string
}

export interface HomeSession {
  id: number
  name: string
  order: number
  type: string
  data: (BannerData | HomeService)[]
  meta_data: Metadata
  title: Label
  hash: string
}

interface Metadata {
  image?: string
  url?: string
  zone_id?: string
  service_icon_threshold?: string
  slide_duration?: string
}

export interface HomeService {
  "@type": string
  id: number
  name: string
  order: number
  title: Title
  url: string
  image: string
  is_new: number
  is_enabled_label: number
  label: Label
  is_enabled: boolean
  android_version: number
  ios_version: number
  max_android_version: number
  max_ios_version: number
  title_key: string
  feature_toggle: string
  disabled_image: string
  promoted: number
  need_updated: boolean
  service_id: string
  web_version: number
  max_web_version: number
}

interface Label {
  en?: string
  vi?: string
}

export interface BannerData {
  "@type": string
  id: number
  name: string
  order: number
  url: string
  image: string
  start_date: string
  end_date: string
  title: Title
  screen_type: number
  zone_id: string
  campaign_id: string
}

interface Title {
  en: string
  vi: string
}

export async function v2GetHomeSession(
  data: v2GetHomeSessionBody
): Promise<AxiosResponse<HomeSessionV2>> {
  return httpPost("be-configuration/customer/get_home_sessions_v2", data)
}

export type v1GetBottomBarBody = {}

export interface v1GetBottomBarResponse {
  icons: Icon[]
}

interface Icon {
  id: number
  name: string
  type: string
  active_image: string
  inactive_image: string
  deep_link: string
  service_name: string
  promoted: number
  promoted_image: string
  title_vi: string
  title_en: string
}

export function v1GetBottomBar(
  data: v1GetBottomBarBody
): Promise<AxiosResponse<v1GetBottomBarResponse>> {
  return httpPost("be-configuration/customer/get_bottom_bar", data)
}
